export default __webpack_public_path__ + "static/media/plugNegativePlugged.08cfc474.svg";